import { Card, Row, Col,Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons'

function Nrc_info(props) {

    const descargar_nrc = ()=>{
        window.print();
    }
    
    const llenar_nrcinfo = ()=>{
        //console.log('AQUI');
        //console.log(props.selectcursos);
        //console.log(Object.keys(props.selectcursos));
        return(
            Object.keys(props.selectcursos).map((key3)=>{            
                let curso = props.selectcursos[key3];
                let titulo = '';
                let nrc = '';
                let profesor = '';
                let cupos = '';
                if(curso.horario !== undefined){
                    if(curso.horario['NOMBRE_ASIGNATURA'] !== null){
                        titulo = curso.horario['NOMBRE_ASIGNATURA'].toUpperCase();
                    }else{
                        titulo = "";
                    }
                    if(curso.horario['NRC'] !== null){
                        nrc = curso.horario['NRC'];
                    }else{
                        nrc = "";
                    } 
                    if(curso.horario['PROFESOR'] !== null){
                        profesor = curso.horario['PROFESOR'].toUpperCase();
                    }else{
                        profesor = "";
                    }
                    if(curso.horario['DISPONIBLES'] !== null){
                        cupos = curso.horario['DISPONIBLES'];
                    }else{
                        cupos = "";
                    }     
               }                
                return(
                    <Col md={12} key={key3}>
                        {curso && curso.matcur_activo && curso.countmax > 0 &&
                        <Card>
                            <Card.Body>
                            <Card.Title><strong>{titulo}</strong></Card.Title>
                            <Card.Text>
                                <p><strong>Nrc: </strong>{nrc}</p>
                                <p><strong>Profesor: </strong>{profesor}</p>
                                <p><strong>Cupos disponibles: </strong>{cupos}</p>
                            </Card.Text>
                            </Card.Body>
                        </Card>
                        }
                    </Col>
                );
            })
        )
    }
    
    return(
        <Row>
            <Col md={12}>
                <span className="text-info info">{props.fecha}</span>
            </Col>

            {llenar_nrcinfo()} 
            
            {Object.keys(props.selectcursos).length > 0 &&
                <Col md={12}>
                    <Button className="btn_icon" variant="success" onClick={descargar_nrc}>
                        <FontAwesomeIcon icon={faFileDownload}/>
                        Descargar nrc
                    </Button>
                </Col> 
            }                     
        </Row>
    );
}


export default Nrc_info;